export default __webpack_public_path__ + "static/email-2c5e8baf351b0652513828ef61b36da8.png";